import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-serach-result',
  templateUrl: './serach-result.component.html',
  styleUrls: ['./serach-result.component.css']
})
export class SerachResultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
